<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm label-width="50" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem>
          <ElInput v-model.trim="keyword" :placeholder="placeholder" style="width: 220px" @keyup.enter.native="search">
            <i slot="append" @click="search" class="el-icon-search"></i>
          </ElInput>
        </ElFormItem>

        <ElFormItem label="游戏组">
          <el-select v-model="gameGroupId" :popper-append-to-body="false" clearable collapse-tags filterable>
            <el-option v-for="item in groupData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="更新人">
          <auto-complete :data="agentData" v-model="agentId" placeholder="全部" @on-select="handleAgent"></auto-complete>
        </ElFormItem>

        <ElFormItem class="bg-transparent">
          <ElButton type="primary" @click="createApp">新建游戏应用</ElButton>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
import AutoComplete from '@/components/autocomplete/autocomplete'
import { isArray } from '@/common/js/utils'
import { getSysMember } from '@/api/common.model'
import { getPtomGroupGames } from '@/api/material.model'

export default {
  name: 'appFilter',
  components: { AutoComplete },
  props: {
    placeholder: {
      type: String
    }
  },
  methods: {
    buildParams() {
      return {
        gameGroupId: this.gameGroupId === -1 ? undefined : this.gameGroupId,
        upOpId: this.agentId === '' ? undefined : this.agentId,
        keyword: this.keyword === '' ? undefined : this.keyword
      }
    },
    sendEvent() {
      this.$emit('on-change', this.buildParams())
    },
    search() {
      this.$emit('on-search', this.buildParams())
    },
    proloadData() {
      Promise.all([getSysMember(), getPtomGroupGames()])
        .then((data) => {
          const [agentData, groupData] = data

          if (isArray(agentData)) {
            this.agentData = agentData
          }

          if (groupData) {
            this.groupData = groupData.map((ret) => {
              return {
                id: ret.groupId,
                name: ret.groupName
              }
            })
          }
          // 初始化
          this.sendEvent()
        })
        .catch((error) => {
          this.$Message.error({
            duration: 5,
            content: error
          })
        })
    },
    handleAgent(meta) {
      this.agentId = meta.id
    },
    createApp() {
      this.$router.push({ name: 'appsadd' })
    }
  },
  watch: {
    gameGroupId(nVal) {
      this.sendEvent()
    },
    agentId(nVal) {
      this.sendEvent()
    }
  },
  data() {
    return {
      keyword: '',
      gameGroupId: '', // 游戏组id
      agentId: '',
      agentData: [],
      groupData: []
    }
  },
  created() {
    this.proloadData()
  }
}
</script>
